import React, { useContext, useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { BrowserRouter } from 'react-router-dom';
import { Spinner } from 'react-bootstrap';
import { Context } from './index';
import AppRouter from './components/AppRouter';
import NavBar from './components/NavBar';
import { check } from './http/userAPI';
import { fetchBasket } from './http/basketAPI';

const App = () => {
    const { user, basket } = useContext(Context);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const token = localStorage.getItem('token');
        if (token) {
            check()
                .then(data => {
                    user.setUser(data);
                    user.setIsAuth(true);
                    return basket.loadBasket();
                })
                .catch((error) => {
                    console.error('Ошибка при загрузке данных:', error);
                    localStorage.removeItem('token');
                    user.setUser({});
                    user.setIsAuth(false);
                    basket.clearBasket();
                })
                .finally(() => {
                    setLoading(false);
                });
        } else {
            setLoading(false);
        }
    }, []);

    if (loading) {
        return (
            <div className="d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
                <Spinner animation="grow" variant="dark" />
            </div>
        );
    }

    return (
        <BrowserRouter>
            <div style={{ backgroundColor: '#ccf2ff', minHeight: '100vh' }}>
                <NavBar />
                <AppRouter />
            </div>
        </BrowserRouter>
    );
};

export default observer(App);
 
